<template>
    <x-page title="Edit Group Role">
        <template #header-actions>
            <x-back-button :disabled="isLoading" />
        </template>
        <group-role-form id="group-role-form"
            v-if="Boolean(resource)"
            @submit="handleSubmit"
            :disabled="isLoading"
            :errors="errors"
            :initialFields="resource" />
        <template #footer>
            <x-submit-button form="group-role-form"
                :is-loading="isLoading"
                :disabled="isLoading" />
        </template>
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import XSubmitButton from '../../components/XSubmitButton.vue'
import { getPreviousUrl, handleGeneralXhrError, handleValidationXhrError } from '../../helpers'
import GroupRoleForm from './GroupRoleForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        XSubmitButton,
        GroupRoleForm,
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/group-roles/${this.$route.params.id}`)
                .then(response => {
                    this.resource = response.data.data
                })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleSubmit(fields) {
            this.isLoading = true
            const request = axios.put(`/api/group-roles/${this.$route.params.id}`, fields)
                .then(() => {
                    this.$notify({
                        type: 'success',
                        title: `Berhasil`,
                        text: `${fields.label} updated!`,
                    })
                    window.location = getPreviousUrl()
                })
            return handleValidationXhrError(request, errors => {
                this.errors = errors
                this.isLoading = false
            })
        },
    },
}
</script>